<template>
  <div class="geofence-list">
    <header-mobile-page label="Our Locations" />
    <geofence-list />
  </div>
</template>

<script>
  import GeofenceList from '@/components/Common/Geofence/GeofenceList.vue'
  import HeaderMobilePage from '@/components/Header/HeaderMobilePage'

  export default {
    components: {
      GeofenceList,
      HeaderMobilePage
    }
  }
</script>

<style lang="scss" scoped>
  .geofence-list {
    width: 100%;
    height: auto;

    padding: 0 0 10px 0;
  }
</style>